import View from 'proposals/components/layout/View'
import ViewHeader from 'proposals/proposal/views/ViewHeader'
import UserFlowCompleted from 'vendors/components/UserFlowCompleted'
import RequestForProposalBasicInfo from 'proposals/requestForProposal/RequestForProposalBasicInfo'
import Box from '@mui/material/Box'
import RequestForProposalDownloadPdf from 'proposals/requestForProposal/RequestForProposalDownloadPdf'
import { EditLayout } from 'proposals/proposal/views/ViewLayout'
import ProposalEditFormContainer from 'proposals/edit/ProposalEditFormContainer'
import ProposalProtectedInfo from 'proposals/proposal/ProposalProtectedInfo'
import { useGetProposalById } from 'proposals/queries/useProposalByIdQuery'
import { Navigate, useParams } from 'react-router-dom'
import { CircularProgress } from '@mui/material'
import { useCallback, useState } from 'react'
import { useLeaveToVendorPortal } from 'proposals/proposal/useLeaveToVendorPortal'

const ProposalEditView = () => {
  const { proposalId } = useParams<{ proposalId: string }>()
  const [isDirty, setIsDirty] = useState(false)
  const leaveToVendorPortal = useLeaveToVendorPortal(isDirty)
  const handleDirtyChange = useCallback((dirty: boolean) => {
    setIsDirty(dirty)
  }, [])

  const { data, isLoading, isError } = useGetProposalById(proposalId as string)

  if (isError) {
    return <Navigate to={`/error`} replace />
  }

  if (isLoading || !data) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', flex: 1, alignItems: 'center' }}>
        <CircularProgress size={24} />
      </Box>
    )
  }

  return (
    <UserFlowCompleted>
      <View>
        <EditLayout>
          <ViewHeader
            title={data.requestForProposal.title}
            logoUrl={data.requestForProposal.tenantLogoUrl}
            onBack={leaveToVendorPortal}
          />
          <Box sx={{ gridArea: 'info', mt: 2 }}>
            <RequestForProposalBasicInfo data={data.requestForProposal} />
            <RequestForProposalDownloadPdf
              rfpId={data.requestForProposal.id}
              rfpTitle={data.requestForProposal.title}
            />
          </Box>
          <Box sx={{ gridArea: 'side-function' }}>
            <ProposalProtectedInfo isProtected={data.requestForProposal.proposalViewingLockedUntilDueDate} />
          </Box>

          <ProposalEditFormContainer
            fields={data.requestForProposal.fields}
            proposal={data.proposal}
            rfpLang={data.requestForProposal.language}
            region={data.tenantRegion}
            onDirtyChange={handleDirtyChange}
          />
        </EditLayout>
      </View>
    </UserFlowCompleted>
  )
}

export default ProposalEditView
